import { LandTitleDto } from "@cradua/data";
import { createAction, props } from "@ngrx/store";

/**
 * Load Acquisition Collection Actions
 */
export const loadAcquisition = createAction("[Acquisition] Load Acquisition");

export const loadAcquisitionSuccess = createAction(
  "[Acquisition] Load Acquisition Success",
  props<{ Acquisition: LandTitleDto[] }>(),
);

export const loadAcquisitionFailure = createAction(
  "[Acquisition] Load Acquisition Failure",
  props<{ error: any }>(),
);

/**
 * Add Acquisition to Collection Actions
 */
export const addAcquisition = createAction(
  "[Acquisition] Add Acquisition",
  props<{
    newAcquisition: LandTitleDto;
  }>(),
);

export const addAcquisitionSuccess = createAction(
  "[Acquisition] Add Acquisition Success",
  props<{ newAcquisition: LandTitleDto }>(),
);

export const addAcquisitionFailure = createAction(
  "[Acquisition] Add Acquisition Failure",
  props<{ error: any }>(),
);

/**
 * Update Acquisition Collection Actions
 */
export const updateAcquisition = createAction(
  "[Acquisition] Update Acquisition",
  props<{ updateAcquisition: LandTitleDto }>(),
);

export const updateAcquisitionSuccess = createAction(
  "[Acquisition] Update Acquisition Success",
  props<{ updateAcquisition: LandTitleDto }>(),
);

export const updateAcquisitionFailure = createAction(
  "[Acquisition] Update Acquisition Failure",
  props<{ error: any }>(),
);

/**
 * Fetch Acquisition-record Collection Actions
 */
export const fetchAcquisitionRecord = createAction(
  "[Acquisition-record] Fetch Acquisition Record",
  props<{ fetch: any }>(),
);

export const fetchAcquisitionRecordSuccess = createAction(
  "[Acquisition-record] Fetch Acquisition Record Success",
  props<{ record: LandTitleDto[] }>(),
);

export const fetchAcquisitionRecordFailure = createAction(
  "[Acquisition-record] Fetch Acquisition Record Failure",
  props<{ error: any }>(),
);

/**
 * Search for record Collection Actions
 */
export const searchAcquisitionRecord = createAction(
  "[Acquisition] Search  Acquisition Record",
  props<{ query: string }>(),
);

/**
 * Search for record Collection Actions
 */
export const searchAcquisitionIdRecord = createAction(
  "[Acquisition] Search  Acquisition Id Record",
  props<{ query: string }>(),
);

/**
 * Remove Acquisition Collection Actions
 */
export const removeAcquisition = createAction(
  "[Acquisition] Remove Acquisition",
  props<{ id: string }>(),
);

export const removeAcquisitionSuccess = createAction(
  "[Acquisition] Remove Acquisition Success",
  props<{ id: string }>(),
);

export const removeAcquisitionFailure = createAction(
  "[Acquisition] Remove Acquisition Failure",
  props<{ error: any }>(),
);



/**
 * Fetch Acquisition-record By Id Collection Actions
 */
export const fetchByIdAcquisitionRecord = createAction(
  "[Acquisition-record] Fetch Acquisition Record By Id",
  props<{ id: string }>(),
);

export const fetchByIdAcquisitionRecordSuccess = createAction(
  "[Acquisition-record] Fetch Acquisition Record By Id Success",
  props<{ record: LandTitleDto[] }>(),
);

export const fetchByIdAcquisitionRecordFailure = createAction(
  "[Acquisition-record] Fetch Acquisition Record By Id Failure",
  props<{ error: any }>(),
);



export const clearAcquisition = createAction("[Acquisition] Clear Acquisition");

export const clearAcquisitionSuccess = createAction(
  "[Acquisition] Clear Acquisition Success",
  props<{ Acquisition: LandTitleDto[] }>(),
);
